export const TransformResponse = (response: any, context: any) => {
    let result: any = {
        success: false,
        error: undefined,
        payload: undefined,
        results: undefined
    };
    
    console.log('TransformResponse - Raw response:', JSON.stringify(response, null, 2));
    console.log('TransformResponse - Checking response properties:', {
        hasResponse: !!response,
        status: response?.status,
        hasError: !!response?.error,
        errorLength: response?.error?.length,
        success: response?.success,
        successType: typeof response?.success,
        hasData: !!response?.data,
        dataSuccess: response?.data?.success
    });
    
    // Extract actual response if nested in data property
    let actualResponse = response;
    if (response && response.data && typeof response.data === 'object') {
        actualResponse = response.data;
    }
    
    // Check for success FIRST (highest priority)
    // If response is an array, it means success (API returns appointment array directly)
    if (Array.isArray(actualResponse) && actualResponse.length > 0) {
        result.success = true;
        result.results = actualResponse;
        result.payload = actualResponse;
    }
    // Check for success object with success: true
    else if (actualResponse && actualResponse.success === true) {
        result.success = true;
        result.results = actualResponse.results;
        result.payload = actualResponse;
    }
    // Check for explicit failure (check both actualResponse and response)
    else if ((actualResponse && actualResponse.success === false) || (response && response.success === false)) {
        result.error = actualResponse || response;
    }
    // Check for HTTP error status
    else if (response && response.status >= 400) {
        console.log('TransformResponse - HTTP error detected:', response.status);
        result.error = response;
    } 
    // Check for API error array (non-empty)
    else if (actualResponse && actualResponse.error && Array.isArray(actualResponse.error) && actualResponse.error.length > 0) {
        result.error = actualResponse;
    }
    // Check for ErrorObject type (from catch block)
    else if (response && response.type === 'error') {
        result.error = response;
    }
    // Unknown response structure
    else {
        console.log('TransformResponse - Full response:', response);
        result.error = response;
    }
        
    return result;
}

